import { render } from "./ManagementDropdown.vue?vue&type=template&id=65b1b098"
import script from "./ManagementDropdown.vue?vue&type=script&lang=js"
export * from "./ManagementDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__